<template>
  <v-app>
    <Sidebar ref="drawer" :items="items"/>
    <Navbar @handleDrawer="$refs.drawer.drawer = !$refs.drawer.drawer"/>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// import Sidebar from '@/components/pageUnits/Sidebar'
import Sidebar from '@/components/pageUnits/TestSidebar'
import Navbar from '@/components/pageUnits/Navbar'
import {main} from '@/router/private/testindex'

export default {
  data: () => ({
    items: main,
    drawer: true,
  }),
  components: {
    Sidebar,
    Navbar
  }
}
</script>
